export function setMeta(name: string, content: string, property = false): void {
  const attribute = property ? 'property' : 'name'
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, name)
    document.head.append(element)
  }
  element.content = content
}

export function setCanonical(url: string): void {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.rel = 'canonical'
    document.head.append(element)
  }
  element.href = url
}

export function resetPageMeta(title: string | undefined, path: string, privatePage: boolean): void {
  document.title = title ? `${title} · 图书馆` : '图书馆'
  setMeta('description', '记录技术、阅读与生活的安静写作空间')
  setMeta('robots', privatePage ? 'noindex, nofollow' : 'index, follow')
  document.head.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]').forEach((element) => element.remove())
  setCanonical(new URL(path, window.location.origin).href)
}

export function setArticleMeta(title: string, description: string, url: string, image: string): void {
  document.title = title
  setMeta('description', description)
  setCanonical(url)
  setMeta('og:type', 'article', true)
  setMeta('og:title', title, true)
  setMeta('og:description', description, true)
  setMeta('og:url', url, true)
  setMeta('og:image', image, true)
  setMeta('twitter:card', image ? 'summary_large_image' : 'summary')
}
